import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

interface AccessDeniedProps {
  titleKey: string;
  messageKey: string;
}

/**
 * Renders a generic access denied view with a localized title and message.
 */
const AccessDenied: React.FC<AccessDeniedProps> = ({ titleKey, messageKey }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: 900,
          minHeight: 360,
          p: { xs: 4, md: 6 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Stack spacing={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
          <Box sx={{ color: 'error.main' }}>
            <FontAwesomeIcon icon={faBan} size="4x" />
          </Box>
          <Typography variant="h4" component="h2">
            {t(titleKey)}
          </Typography>
          <Typography variant="h6" sx={{ color: 'text.secondary' }}>
            {t(messageKey)}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
};

export default AccessDenied;
